import authRules from '../authRules';

const deleteRequest = (user) => {
  const { deleteRequest } = user.securityLevels;
  if (deleteRequest >= authRules.deleteRequest.deleteRequest) {
    return true;
  } else {
    return false;
  }
}

export default deleteRequest;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/deleteRequest.js